import * as React from 'react';
import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import AutoAwesomeRoundedIcon from '@mui/icons-material/AutoAwesomeRounded';
import SvgMaterialDesign from '../../icons/SvgMaterialDesign.tsx';
import AppAppBar from './AppAppBar.js';
import Hero from './Hero.js';
import About from './About.js';
//import LogoCollection from './LogoCollection.js';
// import Testimonials from './Testimonials.js';
import Products from './Products.js';
import Services from './Services.js';
import Demos from './Demos.js';
import Footer from './Footer.js';
import getLPTheme from './getLPTheme.js';

const defaultTheme = createTheme({});

function ToggleCustomTheme({ showCustomTheme, toggleCustomTheme }) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100dvw',
        position: 'fixed',
        bottom: 24,
      }}
    >
      <ToggleButtonGroup
        color="primary"
        exclusive
        value={showCustomTheme}
        onChange={toggleCustomTheme}
        aria-label="Platform"
        sx={{
          backgroundColor: 'background.default',
          '& .Mui-selected': {
            pointerEvents: 'none',
          },
        }}
      >
        <ToggleButton value>
          <AutoAwesomeRoundedIcon sx={{ fontSize: '20px', mr: 1 }} />
          Custom theme
        </ToggleButton>
        <ToggleButton value={false}>
          <SvgMaterialDesign sx={{ fontSize: '20px', mr: 1 }} />
          Material Design
        </ToggleButton>
      </ToggleButtonGroup>
    </Box>
  );
}

ToggleCustomTheme.propTypes = {
  showCustomTheme: PropTypes.shape({
    valueOf: PropTypes.func.isRequired,
  }).isRequired,
  toggleCustomTheme: PropTypes.func.isRequired,
};

export default function LandingPage() {
  const [mode, setMode] = useState(() => {
    return localStorage.getItem('theme') || 'dark'; // Initialize theme from localStorage or fallback to 'dark'
  });

  // Write the current theme to localStorage after initialization
  useEffect(() => {
    localStorage.setItem('theme', mode);
  }, [mode]);
  const [showCustomTheme] = React.useState(true);
  const LPtheme = createTheme(getLPTheme(mode));

  const toggleColorMode = () => {
    setMode((prev) => (prev === 'dark' ? 'light' : 'dark'));
  };

  //const toggleCustomTheme = () => {
  //  setShowCustomTheme((prev) => !prev);
  //};

  return (
    <ThemeProvider theme={showCustomTheme ? LPtheme : defaultTheme}>
      <CssBaseline />
      <AppAppBar mode={mode} toggleColorMode={toggleColorMode} />
      <Hero />
      <Box sx={{ bgcolor: 'background.default' }}>
        <Products />
        <Divider />
        <Services />
        <Divider />
        <Demos />
        <Divider />
        {/* <Testimonials /> */}
        <Divider />
        <About />
        <Footer />
      </Box>
    </ThemeProvider>
  );
}
